import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = ["id", "value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.text, (element) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "radio",
        key: element.key,
        onClick: ($event: any) => (_ctx.pick(element.key))
      }, [
        _withDirectives(_createElementVNode("input", {
          class: "radio-input",
          type: "radio",
          id: element.key,
          value: element.key,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.picked) = $event))
        }, null, 8, _hoisted_2), [
          [_vModelRadio, _ctx.picked]
        ]),
        _createElementVNode("label", null, _toDisplayString(element.text), 1)
      ], 8, _hoisted_1))
    }), 128))
  ]))
}